import React from "react";
import { Container } from "react-bootstrap";
import InfiniteMovingCards from "./InfiniteMovingCards";

const testimonialsRow1 = [
  {
    quote:
      "Smart decisions, clean code, and great collaboration 👌 Looking forward to working together again.",
    name: "Anuj Kumar",
    title: "Computer Science Student | Aspiring SDE | Java | Learning by Building",
    image: "https://media.licdn.com/dms/image/v2/D5603AQFxVgZ7lQBelw/profile-displayphoto-scale_400_400/B56Zt5WmY1JIAg-/0/1767267526980?e=1772064000&v=beta&t=thGavKicTrq-pDziAiA_HrclooLj8pEzOnEr4LVsVaI"
  },
  {
    quote:
      "Keep it up! 🌟 Your enthusiasm for learning and building shows in the results.",
    name: "Suhani Verma",
    title: "Nielsen SWE Intern | SIH’24 Grand Finale Winner 🏆",
    image: "https://media.licdn.com/dms/image/v2/D5603AQHmRPd-2W4swQ/profile-displayphoto-shrink_800_800/B56ZbIT3ZgHUAc-/0/1747117374285?e=1772064000&v=beta&t=Ud9bWjd6dJMC-YEVpgAkpzxCIiAM7RBG9GdGdvOTh-w"
  },
  {
    quote:
      "Your contribution was a game-changer 🔥 Strong technical skills combined with great teamwork.",
    name: "Anushi Rajput",
    title: "Nielsen SWE Intern | JPMC CFG’25 Mumbai Winner ",
    image: "https://media.licdn.com/dms/image/v2/D5603AQFoti2BsK1_4Q/profile-displayphoto-scale_400_400/B56Zsys9fUKAAg-/0/1766082206293?e=1772064000&v=beta&t=a1Ay35e4IKYeawlHxA3WW8uNLiUn6p979MfwSRxA1Mg"
  },
  {
    quote:
      "Great job, Abhinav! 💡 Your ability to turn complex ideas into working solutions is commendable.",
    name: "Monal Sehrawat",
    title: "CMO at Coding Ninjas CUIET | Full Stack Engineer & Developer",
    image: "https://media.licdn.com/dms/image/v2/D5603AQHsdRHdVoek4A/profile-displayphoto-scale_400_400/B56Zk81a4vJ8Ag-/0/1757662275188?e=1772064000&v=beta&t=ie1RnHXe85xnoBfH4pVbVb0gOETP-1XZb-LYMy7-kSU"
  },
  {
    quote:
      "Well deserved! 🚀 Abhinav’s dedication and technical clarity really stood out. Keep up the great work!",
    name: "Harshit Nijhawan",
    title: "Attended Chitkara University, Patiala",
    image: "https://media.licdn.com/dms/image/v2/D4D03AQH-ycd5Q9nVjQ/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1697010069121?e=1772064000&v=beta&t=UlRbM2xp0HdvKtc1-NvWv1BkGb0om6KUkR2DpdnrZiY"
  },
];

const testimonialsRow2 = [
  {
    quote:
      "Excellent execution and clarity 🙌 The project benefited a lot from your structured thinking and clean implementation.",
    name: "Jiya .",
    title: " WWDC25 Swift Student Challenge Winner🏆| Web Developer",
    image: "https://media.licdn.com/dms/image/v2/D4E03AQEOIoTqzstnGA/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1712153907009?e=1772064000&v=beta&t=FKrdBtC2PbpA2m21xvU741pzhkl_5eIJaqrSLIB_9FY"
  },
  {
    quote:
      "Well deserved! 👏 Keep going.",
    name: "Dr. PUNIT SONI",
    title: "Associate Professor | CSE | Chitkara University | Reviewer",
    image: "https://media.licdn.com/dms/image/v2/D4D03AQEm4wcaO_AONQ/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1669281753246?e=1772064000&v=beta&t=-dqQk984xWykTQk4ncpdPFVJshyCVHHWjZ0iUw2Zzy8"
  },
  {
    quote:
      "Really enjoyed collaborating with you ✨ Your approach to building scalable solutions is thoughtful and effective.",
    name: "Pulkit Sulekh",
    title: "Ex-Intern @UNWE, Bulgaria | UG Mechanical Engineer | India Design Week ’25🥉Runner-Up",
    image: "https://media.licdn.com/dms/image/v2/D5603AQHnL6QK_thTjg/profile-displayphoto-scale_400_400/B56ZtlW113JgAg-/0/1766932047028?e=1772064000&v=beta&t=FuXM3bNCWRqo0IGd7BlWDU3QFb7BERjmYFGk7FYRSOQ"
  },
  {
    quote:
      "Well-structured and thoughtful work 🧠",
    name: "Akanksha Mishra",
    title: "Semi Finalist @Flipkart Grid 7.0 || National Finalist @HackIndia’24",
    image: "https://media.licdn.com/dms/image/v2/D5603AQF9Xv4KqGg8Kw/profile-displayphoto-scale_400_400/B56ZpZgNT2JwAk-/0/1762438209520?e=1772064000&v=beta&t=zaUrT_8MFGrV5YHwNAi3myC4FI1X4uKtNssBgoOhXZM"
  },
];

const Clients = () => {
  return (
    <Container fluid className="clients-section">
      <Container>
        <h1 className="project-heading">
          Recognition for My{" "}
          <strong className="purple">Achievements</strong>
        </h1>

        <div className="d-flex flex-column align-items-center" style={{ gap: "0.3rem" }}>
          <InfiniteMovingCards
            items={testimonialsRow1}
            direction="left"
            speed="slow"
          />
          <InfiniteMovingCards
            items={testimonialsRow2}
            direction="right"
            speed="slow"
          />
        </div>
      </Container>
    </Container>
  );
};

export default Clients;
